export const MAX_LOGIN_LOGO_WIDTH = 256
export const CLIENT_IMAGES_MAX_WIDTH = 1256
